import React, { createContext, useState, useContext } from 'react';
import userApi from 'api/requests/user';

const UserContext = createContext();

export default function UserProvider({ children }) {
    const [user, setUser] = useState(null);

    async function getUser() {
        try {
            const { data } = await userApi.me();

            setUser(data);

            return data;
        } catch (error) {
            console.log(error);
            setUser(null)
            return null
        }
    }

    return (
        <UserContext.Provider value={{ user, setUser, getUser }}>
            {children}
        </UserContext.Provider>
    );
}

export function useUser() {
    const context = useContext(UserContext);
    
    if (!context) throw new Error('useUser must be used within a UserProvider');

    return context;
}